// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(true);
// Module
exports.push([module.id, "\n.insured-company{margin-top:7px;display:block\n}\n.snotifyToast__body{width:100%\n}", "",{"version":3,"sources":["unbound-inputs.vue"],"names":[],"mappings":";AAAA,iBAAiB,cAAA,CAAe;AAEhC;AAF8C,oBAAoB;AAIlE","file":"unbound-inputs.vue","sourcesContent":[".insured-company{margin-top:7px;display:block}.snotifyToast__body{width:100%}"]}]);
// Exports
module.exports = exports;
